export default [
  {
    title: 'breadcrumb.rolePermission',
    route: 'list-role-permission',
    icon: '',
    resource: 'role-permission',
    action: 'read'
  }
];